import React from "react";
import {CrowdedStepGuideList} from "../../../constants/list/CrowdedStepGuideList";

interface Props {}
interface State {}

export default class CrowdedStepGuideContent extends React.Component<Props, State> {

  renderItem = () => {
    return CrowdedStepGuideList.map((i, index) => {
      return (
        <div key={index} style={{display: "flex", alignItems: "center", flexDirection: "row", borderBottom: `${CrowdedStepGuideList.length - 1 === index ? 0 : 1}px solid #FFFFFF`}}>
          <div style={{padding: "18px 0 15px 0", textAlign: "center"}}>
            <div style={{margin: "0 20px"}}>{i.icon}</div>
            <div style={{height: 11}}/>
            <span style={{fontSize: 15, fontWeight: "bold"}}>{i.step}단계 <span style={{color: "#03A8A8"}}>{i.status}</span></span>
          </div>
          <div style={{padding: "8px 9px 8px 9px", fontSize: 15, borderLeft: "1px solid #FFFFFF", }}>
            <div className={"row"} style={{fontWeight: "bold", color: "#03A8A8"}}>
              <span style={{backgroundColor: "#00000070", borderRadius: 10, border: "1px solid #03A8A8", padding: "5px 30px", marginRight: 10}}>인구 범례</span>
              <span>{i.range1} <span style={{color: "#CCCCCC"}}>/</span> {i.range2}</span>
            </div>
            <div style={{height: 5}}/>
            <div style={{lineHeight: 1.5}}>
              {i.content}
            </div>
          </div>
        </div>
      )
    });
  }

  render() {
    return (
      <div style={{backgroundColor: "#242834", color: "#FFFFFF", borderRadius: 10}}>
        {this.renderItem()}
      </div>
    );
  }
}
